module.exports = __webpack_public_path__ + "media/CC_amex.3496e1fb.png";